import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Button from 'jbc-front/components/Button';
import compose from 'lodash/fp/compose';
import CommonModal from 'jbc-front/components/CommonModal';
import { deleteCompany } from 'src/reducers/clients/clients';
import { useTranslation } from 'react-i18next';

const DeleteCompanyConfirmModal = ({ hideModal, isOpen, company, dispatch}) => {
  const { t } = useTranslation();
  const onSubmit = () => {
    dispatch(deleteCompany(company.id));
    hideModal();
  };

  return (
    <React.Fragment>
      <CommonModal hideModal={hideModal} isOpen={isOpen} ariaHideApp={false}>
        <CommonModal.Header hideModal={hideModal}>{t('features.Clients.components.DeleteCompanyConfirmModal.confirm_of_delete')}</CommonModal.Header>
        <CommonModal.Body>
          <div>{t('features.Clients.components.DeleteCompanyConfirmModal.are_you_sure_to_delete_office_and_branch')}</div>
        </CommonModal.Body>
        <CommonModal.Footer>
          <Button onClick={hideModal} className="u-mr20">
            {t('features.Clients.components.DeleteCompanyConfirmModal.cancel')}
          </Button>
          <Button primary onClick={onSubmit} className="u-mr20">
            {t('features.Clients.components.DeleteCompanyConfirmModal.delete')}
          </Button>
        </CommonModal.Footer>
      </CommonModal>
    </React.Fragment>
  );
};

export default compose(connect())(DeleteCompanyConfirmModal);
